import { getRoleMenus } from "@/api/permission"
import { asyncRoutes, constantRoutes } from "@/router/routerMap"
import {
  buildMenuTree,
  filterRoutesByMenuKeys,
  flattenMenuKeys
} from "@/utils/menuPermission"

const state = {
  routes: constantRoutes,
  addRoutes: [],
  menuKeys: [],
  loaded: false
}

const mutations = {
  SET_ROUTES(state, routes) {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  },
  SET_MENU_KEYS(state, menuKeys) {
    state.menuKeys = menuKeys
  },
  SET_LOADED(state, loaded) {
    state.loaded = loaded
  },
  RESET_PERMISSION(state) {
    state.routes = constantRoutes
    state.addRoutes = []
    state.menuKeys = []
    state.loaded = false
  }
}

const actions = {
  async generateRoutes({ commit }) {
    const response = await getRoleMenus()
    const data = (response && response.data) || {}
    const allMenuKeys = flattenMenuKeys(buildMenuTree(asyncRoutes))
    const menuKeys = data.configured ? data.menu_keys || [] : allMenuKeys
    const accessRoutes = data.configured
      ? filterRoutesByMenuKeys(asyncRoutes, menuKeys)
      : asyncRoutes

    commit("SET_MENU_KEYS", menuKeys)
    commit("SET_ROUTES", accessRoutes)
    commit("SET_LOADED", true)
    return accessRoutes
  },
  resetRoutes({ commit }) {
    commit("RESET_PERMISSION")
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
